import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import axios from "axios";
import $ from "jquery";
import { MDBTableEditable } from "../_mdbcomponents/components/pro/TableEditable/TableEditable";
import { MDBCard } from "../_mdbcomponents/components/Card/Card";
import { MDBCardHeader } from "../_mdbcomponents/components/Card/CardHeader/CardHeader";
import { MDBCardBody } from "../_mdbcomponents/components/Card/CardBody/CardBody";
import { InterModularSidebar } from "../Layouts/InterModularSidebar";
import { Preview, print } from "react-html2pdf";
import Select from "react-select";
import makeAnimated from "react-select/animated";

export class TestsToBeDoneInLab extends Component {
  constructor(props) {
    super(props);
   
    const url = "";

    var values = [];
    this.state = {
      chiefComplaint: "",
      historyofPresentIllness: "",
      physicalGeneral: "",
      obstetricGynecologicalExam: "",
      // diagnosis: "",
      plan: "",
      treatment: "",

      options: {},
      diagnosis: [],
      patientName: localStorage.getItem("currentVisitName"),
      loading:false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.PrintWindow = this.PrintWindow.bind(this);

    this.handleMultiChange = this.handleMultiChange.bind(this);
  }

  handleMultiChange(option) {
    this.setState({
      diagnosis: option,
    });
  }

  componentDidMount() {
    $(".plus_btn").click(function () {
      $(".ICDhidden").show();
    });

    const options = [
      { label: "bloodglucoserbs", value: "bloodglucoserbs" },
      { label: "bloodglucosefbs", value: "bloodglucosefbs" },
      { label: "bloodglucosehba1", value: "bloodglucosehba1" },
      { label: "livergot", value: "livergot" },
      { label: "livergpt", value: "livergpt" },
      { label: "livertotalbilr", value: "livertotalbilr" },
      { label: "liverdirectbilr", value: "liverdirectbilr" },
      { label: "liveralkphos", value: "liveralkphos" },
      { label: "liverggt", value: "liverggt" },
      { label: "livertotalprotein", value: "livertotalprotein" },
      { label: "liveralbumin", value: "liveralbumin" },
      { label: "lipidcholesterol", value: "lipidcholesterol" },
      { label: "lipidtriglyceride", value: "lipidtriglyceride" },
      { label: "lipidhdl", value: "lipidhdl" },
      { label: "lipidldl", value: "lipidldl" },
      { label: "renalcreatinine", value: "renalcreatinine" },
      { label: "renalurea", value: "renalurea" },
      { label: "renalsodium", value: "renalsodium" },
      { label: "renalpotassium", value: "renalpotassium" },
      { label: "renalcalcium", value: "renalcalcium" },
      { label: "renalchloride", value: "renalchloride" },
      { label: "renalphosphorus", value: "renalphosphorus" },

      { label: "UricAcid", value: "UricAcid" },
      { label: "thyroidt3", value: "thyroidt3" },
      { label: "thyroidt4", value: "thyroidt4" },
      { label: "thyroidtsh", value: "thyroidtsh" },
      { label: "coagulationpt", value: "coagulationpt" },
      { label: "coagulationptt", value: "coagulationptt" },
      { label: "coagulationaptt", value: "coagulationaptt" },
      { label: "elisameaslesigm", value: "elisameaslesigm" },
      { label: "elisarubellaigm", value: "elisarubellaigm" },
      { label: "elisahbsag", value: "elisahbsag" },
      { label: "elisahcv", value: "elisahcv" },

      { label: "seraso", value: "seraso" },
      { label: "serwidal", value: "serwidal" },
      { label: "serhpylori", value: "serhpylori" },
      { label: "serbrucella", value: "serbrucella" },
      { label: "serrf", value: "serrf" },
      { label: "sercrp", value: "sercrp" },
      { label: "serrprvdrl", value: "serrprvdrl" },
      { label: "serrvi", value: "serrvi" },
      { label: "sertpha", value: "sertpha" },
      { label: "serpsa", value: "serpsa" },
      { label: "serhbsag", value: "serhbsag" },
      { label: "serhcv", value: "serhcv" },
      { label: "sertoxopla", value: "sertoxopla" },

      { label: "seresr", value: "seresr" },
      { label: "serhb", value: "serhb" },
      { label: "serhct", value: "serhct" },
      { label: "serwbc", value: "serwbc" },
      { label: "serdc", value: "serdc" },
      { label: "sern", value: "sern" },
      { label: "serl", value: "serl" },
      { label: "serm", value: "serm" },
      { label: "sere", value: "sere" },
      { label: "serb", value: "serb" },

      { label: "malaria", value: "malaria" },

      { label: "uriappearance", value: "uriappearance" },
      { label: "uriph", value: "uriph" },
      { label: "uriprotein", value: "uriprotein" },
      { label: "uriglucose", value: "glucouriglucosese" },
      { label: "uribilirubin", value: "uribilirubin" },

      { label: "sedwbc", value: "sedwbc" },
      { label: "sedrbc", value: "sedrbc" },
      { label: "sede2cells", value: "sede2cells" },
      { label: "sedcasts", value: "sedcasts" },
      { label: "sedothers", value: "sedothers" },

      { label: "pregnancy", value: "pregnancy" },

      { label: "stoolappearance", value: "stoolappearance" },
      { label: "stoolconsistency", value: "stoolconsistency" },
      { label: "stoolmicroscopy", value: "stoolmicroscopy" },

      { label: "diagnosticstudies", value: "diagnosticstudies" },

      
    ];

    this.setState({
      options: options,
    });
  }

  

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }
  onTableChange(event) {}

  proceedEvent(event) {
    window.location.href = "/triage/admission/triage";
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };
    event.preventDefault();
    console.log(localStorage.getItem("accessToken"));
    console.log(this.state.diagnosis);
    var values = [];
    var icdict = [];
    var obj = new Object();
   
    for (var i = 0; i < this.state.diagnosis.length; i++) {
      

      icdict.push(this.state.diagnosis[i]["label"]);
    }
    // console.log(icdict)

    var dict = new Object();
    dict["requestsdict"] = icdict;
    this.setState({
      loading: true
    })
    axios
      .post(
        this.api_url+"laboratory/requests/triage/off",
        dict,
        {
          headers: headers,
        }
      )
      .then((response) => {
        console.log(response);
        this.setState({
          loading: false
        })
        if (response.data["status"]) {
          $(".alert-success").show();
          setTimeout(function () {
            // alert('sdsd')
            window.location.href = "/send/to/module";
          }, 1500);
        }
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  };

  formatTableOutput(data) {
    let topobj = {};
    let tableobj = {};
    for (let i = 0; i < data.length; i++) {
      let trim = data[i];
      let trimobj = {};
      this.setState({
        Year: "1212",
      });

      trimobj.Route = data[i][0];
      trimobj.DrugName = data[i][1];
      trimobj.Dosage = data[i][2];
      trimobj.Frequency = data[i][3];
      trimobj.Duration = data[i][4];
      trimobj.DrugAdministration = data[i][6];
      trimobj.midwifenursename = data[i][7];
      trimobj.remarks = data[i][8];

      tableobj[i] = trimobj;
      topobj.prepplan = tableobj;
    }
    this.state.tablevaluesglobal = topobj["prepplan"];
    console.log(this.state.tablevaluesglobal);
  }

  handleTableChange(event) {}

  getTableValues(event) {
    var data = event;
    let topobj = {};
    let tableobj = {};
    // console.log(event.length)
    // var data = event.
    // for (let i = 0; i < data.length; i++) {
    //     let trim = data[i];
    let trimobj = {};
    this.setState({
      Year: "1212",
    });
    console.log(data[0]);
    trimobj.Route = data[0][0];
    trimobj.DrugName = data[0][1];
    trimobj.Dosage = data[0][2];
    trimobj.Frequency = data[0][3];
    trimobj.Duration = data[0][4];
    trimobj.DrugAdministration = data[0][5];
    trimobj.midwifenursename = data[0][6];
    trimobj.remarks = data[0][7];

    tableobj = trimobj;
    topobj.prepplan = tableobj;
    // }
    this.state.tablevaluesglobal = topobj["prepplan"];
    console.log(this.state.tablevaluesglobal);
    // let tablevalues = this.formatTableOutput(event);
    // console.log(tablevalues);
  }

  render() {
    //Editable table variables
    const data = [["", "", "", "", "", "", "", ""]];

    const columns = [
      "Sn",
      "Route",
      "Drug Name",
      "Dosage",
      "Frequency",
      "Duration",
      "Doctor`s Remarks",
      "Name of Doctor",
    ];

    const font16 = { fontSize: "22px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };
    const width100 = { width: "100%" };
    const autoscroll = { overflowY: "auto" };

    const { diagnosis, options, patientName, loading } = this.state;

    return (
      <div>
        <Headers />
        <InterModularSidebar />

        <main className="content-container">
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="form-row pt-4">
                <div className="col-md-12 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      {" "}
                      Tests to be done
                    </h6>

                    <Select
                      options={options}
                      style={width100}
                      value={diagnosis}
                      name="filters"
                      onChange={this.handleMultiChange}
                      isSearchable
                      isMulti
                    />
                  </div>
                </div>
              </div>
              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Details Saved Successfully.
              </div>

              <div className="row">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                   {loading ? 'Loading' : 'Submit'} 
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default TestsToBeDoneInLab;
